import React from 'react'
interface HeadingProps {
    name: string,
    isAboutIssuer?: boolean
}
const Heading = ({ name, isAboutIssuer }: HeadingProps) => {
    return (
        <>
            {isAboutIssuer && <span style={{ height: "15px" }} />}
            {/* <tr className="bg-light-th-head">
                <th colSpan={4}> */}
                    <h2 className="fw-bold m-0 py-2 bg-light-th-head px-2" style={{ fontSize: "13px" }}>
                        {name}
                    </h2>
                {/* </th>
            </tr> */}
        </>
    )
}

export default React.memo(Heading);